import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const sendSubscribe = (email, code) =>
  axios({
    method: 'post',
    url: `${publicAPI}/deliveryzone/subscribe`,
    data: { email, code },
  });
